import { z } from 'zod';

const ModuleActivityExtraDataSchema = z.object({
  module_id: z.string().min(1),
});

export const parseModuleActivityModuleId = (raw: unknown): string | null => {
  const result = ModuleActivityExtraDataSchema.safeParse(raw);
  return result.success ? result.data.module_id : null;
};
